<div
  style="position: absolute; gap: 240px; height: 49px"
  class="flag-managing d-flex flex justify-content-between"
  *ngIf="selectedGroups?.length">
  <div style="display: flex; align-items: center">
    <h3 class="title">Groups selected: {{ selectedGroups?.length }}</h3>
    <div style="display: flex; padding: 8px 16px; justify-content: center; align-items: center">
      <button class="btn btn-link" (click)="selectAll()" style="padding: 0">Select all</button>
      <span>/</span>
      <button class="btn btn-link" (click)="unSelectAll()" style="padding: 0">Deselect all</button>
    </div>
  </div>

  <div class="d-flex" style="width: fit-content; text-align: end; gap: 16px">
    <button class="btn btn-aru-icon" [disabled]="!selectedGroups?.length" (click)="removeGroups.emit(selectedGroups)">
      <img class="icon-delete" src="assets/img/delete.svg" alt="" />
      <span class="delete-btn">Delete</span>
    </button>
    <button class="btn btn-aru" [disabled]="!canMerge()" (click)="selectTargetGroup()">
      <span>Merge groups</span>
    </button>
    <div class="cross" (click)="unSelectAll()" style="padding: 0">
      <img class="icon-cross" src="assets/img/x.svg" alt="" />
    </div>
  </div>
</div>

<app-flag-manager-group-picker #groupPicker></app-flag-manager-group-picker>
